export default function handleFormatHourFromDate(date: string): string {
  return `${date.split('T')[1].split('.')[0].split(':')[0]}:${
    date.split('T')[1].split('.')[0].split(':')[1]
  }`;
}
